;(() => {
  function wireRecipeVideo(video) {
    if (video.dataset.boundWire === 'true') return
    const wrapper = video.closest('.video-guide__item-video')

    video.addEventListener('pointerup', (e) => {
      if (video.controls) return
      if (e.target !== video) return
      if (video.paused) video.play()
      else video.pause()
    })

    video.addEventListener('play', () => {
      video.controls = true
      wrapper?.classList.add('play')
    })

    video.addEventListener('pause', () => {
      wrapper?.classList.remove('play')
      setTimeout(() => {
        if (video.paused) video.controls = false
      }, 200)
    })

    video.addEventListener('ended', () => {
      wrapper?.classList.remove('play')
      setTimeout(() => {
        video.controls = false
      }, 0)
    })

    video.dataset.boundWire = 'true'
  }

  function bindRecipeVideos(root = document) {
    root.querySelectorAll('.recipe-list .video-player').forEach(wireRecipeVideo)
  }

  document.addEventListener('shopify:section:load', (e) => {
    bindRecipeVideos(e.target)
  })

  document.addEventListener('DOMContentLoaded', () => {
    const blogUrl = '/blogs/recipes'
    const grid = document.querySelector('.recipe-list')
    const posts = document.querySelectorAll('.recipe-list__item')
    const checkboxes = document.querySelectorAll(
      '.checkbox-item input[type="checkbox"]'
    )
    const tabs = document.querySelectorAll('.recipe-tabs button')
    const applyBtn = document.querySelector('.recipe-filter__btn-apply')
    const clearBtn = document.querySelector('.recipe-filter__btn-clear')
    const filterCountSpan = document.querySelector('.filter-selected-count')
    const activeFiltersContainer = document.querySelector(
      '.recipe-active-filters'
    )
    const filterExpandBtns = document.querySelectorAll(
      '.recipe-filter__group-title'
    )
    const totalCount = document.querySelector('.recipe-toolbar__total-count')
    const emptyResultBox = document.querySelector('.recipe-list-empty')
    const emptyClearBtn = document.querySelector(
      '.recipe-list-empty__clear-btn'
    )

    // Masonry 인스턴스 초기화
    const msnry = new Masonry(grid, {
      itemSelector: '.recipe-list__item',
      columnWidth: '.recipe-list__sizer',
      gutter: 20,
      percentPosition: true,
      horizontalOrder: true,
    })

    /**
     * 필터 그룹 이름을 게시물의 data 속성 키로 변환
     * @param {string} group - 필터 그룹 이름 (예: 'recipe-type')
     * @returns {string} 변환된 데이터 속성 키 (예: 'filterRecipeType')
     */
    const getPostDataKey = (group) => {
      switch (group) {
        case 'recipe-type':
          return 'filterRecipeType'
        case 'recipe-ingredient':
          return 'filterRecipeIngredient'
        case 'recipe-phyto':
          return 'filterRecipePhyto'
        case 'recipe-diet-type':
          return 'filterRecipeDietType'
        default:
          return ''
      }
    }

    /**
     * 현재 선택된 모든 체크박스 필터를 객체 형태로 가져오기
     * @returns {object} 그룹별로 정리된 필터 값 객체
     */
    const getSelectedCheckboxFilters = () => {
      const selectedFilters = {}
      document
        .querySelectorAll('.checkbox-item input:checked')
        .forEach((checkbox) => {
          const group = checkbox.dataset.filterGroup
          if (!selectedFilters[group]) {
            selectedFilters[group] = []
          }
          selectedFilters[group].push(checkbox.value)
        })
      return selectedFilters
    }

    /**
     * 활성화된 탭에 맞춰 각 필터의 게시물 개수를 업데이트
     */
    const updateFilterCountsByTab = () => {
      const activeTab = document.querySelector('.recipe-tabs button.s-active')
      const activeTagFilter = activeTab ? activeTab.dataset.filter : 'All'

      checkboxes.forEach((checkbox) => {
        let count = 0
        const group = checkbox.dataset.filterGroup
        const value = checkbox.value.toUpperCase()
        const postFilterDataKey = getPostDataKey(group)

        posts.forEach((post) => {
          const postTags = post.dataset.tags.split(',')
          const isTabMatch =
            activeTagFilter === 'All' || postTags.map(t => t.trim().toUpperCase()).includes(activeTagFilter.toUpperCase())

          if (isTabMatch && post.dataset[postFilterDataKey]) {
            const postGroupTags = post.dataset[postFilterDataKey]
              .toUpperCase()
              .split(',')
            if (postGroupTags.includes(value)) {
              count++
            }
          }
        })

        const countSpan = checkbox
          .closest('li')
          .querySelector('.recipe-filter__count')
        if (countSpan) {
          countSpan.textContent = `${count}`
        }
      })
    }

    /**
     * 선택된 필터의 총 개수를 업데이트
     */
    const updateSelectedFilterCount = () => {
      const checkedCount = document.querySelectorAll(
        '.checkbox-item input:checked'
      ).length
      if (filterCountSpan) {
        filterCountSpan.textContent = `${checkedCount}`
      }
    }

    /**
     * 현재 활성화된 필터 목록 렌더링
     */
    const renderActiveFilters = () => {
      if (!activeFiltersContainer) return

      const checkedBoxes = document.querySelectorAll(
        '.checkbox-item input:checked'
      )

      if (checkedBoxes.length === 0) {
        activeFiltersContainer.innerHTML = ''
        return
      }

      let filterTagsHTML = ''
      checkedBoxes.forEach((checkbox) => {
        const labelText = checkbox.nextElementSibling.textContent
        filterTagsHTML += `
          <button type="button" class="chip recipe-active-filters__btn-remove" data-value="${checkbox.value}" aria-label="Remove ${labelText} from selected filter">
            <span>${labelText}</span>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.42919 2.57129L2.57227 9.42822M9.42919 9.42843L2.57227 2.5715" stroke="#565450" stroke-width="0.86" stroke-linecap="round"/>
            </svg>
          </button>
        `
      })

      const clearAllBtnHTML = `<button type="button" class="recipe-active-filters__btn-clear-all typo-inter-caption-1">Clear All</button>`
      activeFiltersContainer.innerHTML = filterTagsHTML + clearAllBtnHTML
    }

    /**
     * URL의 쿼리 스트링을 현재 필터 상태에 맞게 업데이트
     */
    const updateUrlWithFilters = () => {
      const newParams = new URLSearchParams()
      const activeTab = document.querySelector('.recipe-tabs button.s-active')
      const selectedCheckboxFilters = getSelectedCheckboxFilters()

      if (activeTab && activeTab.dataset.filter !== 'All') {
        newParams.set('tag', activeTab.dataset.filter)
      }

      for (const group in selectedCheckboxFilters) {
        if (selectedCheckboxFilters[group].length > 0) {
          newParams.set(group, selectedCheckboxFilters[group].join(','))
        }
      }

      const finalUrl = newParams.toString()
        ? `${blogUrl}?${newParams.toString()}`
        : blogUrl
      window.history.pushState({ path: finalUrl }, '', finalUrl)
    }

    /**
     * 게시물 노출처리
     */
    const applyAllFilters = () => {
      const activeTab = document.querySelector('.recipe-tabs button.s-active')
      const activeTagFilter = activeTab ? activeTab.dataset.filter : 'All'
      const selectedCheckboxFilters = getSelectedCheckboxFilters()

      let visibleItemsCount = 0

      posts.forEach((post) => {
        const isTabMatch =
          activeTagFilter === 'All' ||
          post.dataset.tags.split(',').map(t => t.trim().toUpperCase()).includes(activeTagFilter.toUpperCase())
        let isCheckboxMatch = true

        for (const group in selectedCheckboxFilters) {
          const requiredTags = selectedCheckboxFilters[group]
          const postFilterDataKey = getPostDataKey(group)
          const postTagsForGroup = post.dataset[postFilterDataKey]
            ? post.dataset[postFilterDataKey].toUpperCase().split(',')
            : []

          const hasMatchInGroup = requiredTags.some((tag) =>
            postTagsForGroup.includes(tag.toUpperCase())
          )

          if (!hasMatchInGroup) {
            isCheckboxMatch = false
            break
          }
        }

        // post.style.display = isTabMatch && isCheckboxMatch ? 'block' : 'none'
        if (isTabMatch && isCheckboxMatch) {
          post.style.display = 'block'
          visibleItemsCount++
        } else {
          post.style.display = 'none'
        }
      })

      updateUrlWithFilters()
      renderActiveFilters()
      msnry.layout()

      // emptyResultBox
      if (emptyResultBox) {
        visibleItemsCount === 0
          ? emptyResultBox.classList.add('s-empty')
          : emptyResultBox.classList.remove('s-empty')
      }
      totalCount.textContent = visibleItemsCount
    }

    /**
     * 페이지 로드 시 URL 쿼리 스트링을 읽어 필터 상태 복원
     */
    const applyFiltersFromUrl = () => {
      const params = new URLSearchParams(window.location.search)
      const currentTag = params.get('tag') || 'All'

      tabs.forEach((tab) => {
        const isSelected = tab.dataset.filter.toUpperCase() === currentTag.toUpperCase()
        tab.classList.toggle('s-active', isSelected)
        tab.setAttribute('aria-selected', isSelected)
      })
      checkboxes.forEach((checkbox) => {
        const group = checkbox.dataset.filterGroup
        const values = params.get(group)?.split(',') || []
        checkbox.checked = values.includes(checkbox.value)
      })

      updateSelectedFilterCount()
      updateFilterCountsByTab()
      applyAllFilters()
    }

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((t) => {
          t.classList.remove('s-active')
          t.setAttribute('aria-selected', 'false')
        })
        tab.classList.add('s-active')
        tab.setAttribute('aria-selected', 'true')
        updateFilterCountsByTab()
        applyAllFilters()
      })
    })

    checkboxes.forEach((checkbox) => {
      checkbox.addEventListener('change', updateSelectedFilterCount)
    })

    if (applyBtn) {
      applyBtn.addEventListener('click', applyAllFilters)
    }

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        checkboxes.forEach((checkbox) => (checkbox.checked = false))
        updateSelectedFilterCount()
        applyAllFilters()
      })
    }

    if (emptyClearBtn) {
      emptyClearBtn.addEventListener('click', () => {
        checkboxes.forEach((checkbox) => (checkbox.checked = false))
        updateSelectedFilterCount()
        applyAllFilters()
      })
    }
    // 활성화된 필터 목록 클릭 이벤트 처리
    activeFiltersContainer.addEventListener('click', (event) => {
      const removeBtn = event.target.closest(
        '.recipe-active-filters__btn-remove'
      )
      const clearAllBtn = event.target.closest(
        '.recipe-active-filters__btn-clear-all'
      )

      if (removeBtn) {
        const valueToRemove = removeBtn.dataset.value
        const checkboxToUncheck = document.querySelector(
          `.checkbox-item input[value="${valueToRemove}"]`
        )
        if (checkboxToUncheck) {
          checkboxToUncheck.checked = false
          updateSelectedFilterCount()
          applyAllFilters()
        }
        return
      }

      if (clearAllBtn && clearBtn) {
        clearBtn.click()
      }
    })

    filterExpandBtns.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const isExpanded = trigger.getAttribute('aria-expanded') === 'true'
        const content = trigger.nextElementSibling

        if (isExpanded) {
          trigger.setAttribute('aria-expanded', 'false')
          content.hidden = true
        } else {
          trigger.setAttribute('aria-expanded', 'true')
          content.hidden = false
        }
      })
    })

    applyFiltersFromUrl()

    bindRecipeVideos(document)
  })
})()
